import CreateIndexForm from './CreateIndexForm.component';

export default CreateIndexForm;